"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appWithMetaData = exports.getMetaDataPageProp = exports.META_DATA_PROP = void 0;
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const next_i18next_1 = require("next-i18next");
const head_1 = __importDefault(require("next/head"));
const react_1 = __importStar(require("react"));
const libs_context_page_type_1 = require("@hotelplan/libs.context.page-type");
const libs_feature_toggle_1 = require("@hotelplan/libs.feature-toggle");
const libs_next_utils_1 = require("@hotelplan/libs.next-utils");
const fdr_lib_i18n_lang_config_1 = require("@hotelplan/fdr.lib.i18n.lang-config");
const fdr_lib_page_available_pages_1 = require("@hotelplan/fdr.lib.page.available-pages");
const meta_data_context_1 = require("./meta-data.context");
exports.META_DATA_PROP = 'meta';
const GLOBAL_NO_INDEX = 'global-no-index';
const DEFAULT_NO_FOLLOWED_PAGES = [
    fdr_lib_page_available_pages_1.EPageType.OnDemandCatalog,
    fdr_lib_page_available_pages_1.EPageType.Page_404,
    fdr_lib_page_available_pages_1.EPageType.MyaccountLogin,
    fdr_lib_page_available_pages_1.EPageType.MyaccountRegistration,
    fdr_lib_page_available_pages_1.EPageType.MyaccountConfirmation,
    fdr_lib_page_available_pages_1.EPageType.MyaccountResetPassword,
    fdr_lib_page_available_pages_1.EPageType.NewsletterSubscription,
    fdr_lib_page_available_pages_1.EPageType.NewsletterConfirmation,
    fdr_lib_page_available_pages_1.EPageType.NewsletterFinalization,
    fdr_lib_page_available_pages_1.EPageType.NewsletterUnsubscription,
    fdr_lib_page_available_pages_1.EPageType.NewsletterUnsubscriptionFinalization,
    fdr_lib_page_available_pages_1.EPageType.EmailAdvertisingRevocation,
    fdr_lib_page_available_pages_1.EPageType.EmailAdvertisingRevocationConfirmation,
];
const propGetter = (0, libs_next_utils_1.createPagePropGetter)(exports.META_DATA_PROP, null);
function getMetaDataPageProp(pageProps) {
    return propGetter(pageProps);
}
exports.getMetaDataPageProp = getMetaDataPageProp;
function appWithMetaData(options = {}) {
    return function (WrappedAppComponent) {
        function AppWithMetaData(props) {
            var _a, _b;
            const { pageProps } = props;
            const [, { language = fdr_lib_i18n_lang_config_1.languageDefault }] = (0, next_i18next_1.useTranslation)();
            const metaDataContext = getMetaDataPageProp(pageProps);
            const pageType = (0, libs_context_page_type_1.getPageTypeProp)(pageProps);
            const featureToggleConfig = (_a = (0, libs_feature_toggle_1.getFeatureTogglePageProp)(pageProps)) === null || _a === void 0 ? void 0 : _a.config;
            let metaDataOptions;
            if (typeof options === 'function') {
                metaDataOptions = options({
                    language,
                });
            }
            else {
                metaDataOptions = options;
            }
            const { favIconDefault = `/favicon.ico`, favIconSvg, favIconColor, appleTouchIcon, webManifest, noFollowedPages = DEFAULT_NO_FOLLOWED_PAGES, globalNoIndexFeatureToggleName = GLOBAL_NO_INDEX, } = metaDataOptions;
            const { title, description, keywords, noFollow, index, icon = favIconDefault, } = metaDataContext || {};
            const globalNoIndex = (_b = featureToggleConfig === null || featureToggleConfig === void 0 ? void 0 : featureToggleConfig[globalNoIndexFeatureToggleName]) === null || _b === void 0 ? void 0 : _b.enabled;
            const isNoFollowedPage = (0, react_1.useMemo)(() => noFollowedPages.includes(pageType), [noFollowedPages, pageType]);
            const indexTag = (0, react_1.useMemo)(function () {
                if (globalNoIndex) {
                    return (react_1.default.createElement("meta", { key: "robots", name: "robots", content: "noindex, nofollow" }));
                }
                // Check if index is true
                if (index) {
                    return react_1.default.createElement("meta", { key: "robots", name: "robots", content: "index, follow" });
                }
                // Check if index is false
                if (index === false) {
                    return (react_1.default.createElement("meta", { key: "robots", name: "robots", content: `noindex, ${isNoFollowedPage ? 'nofollow' : 'follow'}` }));
                }
                // Add noFollow only if no index is set
                if (!index && noFollow) {
                    return react_1.default.createElement("meta", { key: "robots", name: "robots", content: "nofollow" });
                }
                return null;
            }, [index, isNoFollowedPage, noFollow]);
            return (react_1.default.createElement(meta_data_context_1.MetaDataContext.Provider, { value: metaDataContext },
                react_1.default.createElement(head_1.default, null,
                    title && react_1.default.createElement("title", { key: "title" }, title),
                    description && (react_1.default.createElement("meta", { key: "desc", name: "description", content: description })),
                    keywords && react_1.default.createElement("meta", { name: "keywords", content: keywords }),
                    indexTag,
                    icon && (react_1.default.createElement("link", { key: "favi", rel: "shortcut icon", href: icon, type: "image/ico" })),
                    favIconSvg ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("link", { rel: "icon", href: favIconSvg, type: "image/svg+xml" }),
                        react_1.default.createElement("link", { rel: "mask-icon", href: favIconSvg, sizes: "any", color: favIconColor ? favIconColor : '#FF0000' }))) : null,
                    appleTouchIcon ? (react_1.default.createElement("link", { rel: "apple-touch-icon", href: appleTouchIcon })) : null,
                    webManifest ? react_1.default.createElement("link", { rel: "manifest", href: webManifest }) : null),
                react_1.default.createElement(WrappedAppComponent, Object.assign({}, props))));
        }
        return (0, hoist_non_react_statics_1.default)(AppWithMetaData, WrappedAppComponent);
    };
}
exports.appWithMetaData = appWithMetaData;
//# sourceMappingURL=app-with-meta-data.js.map